// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__L2Vtu","content":"Layout_content__PrPCk","flex":"Layout_flex__8QIxL","children":"Layout_children__ibuH0"};